import { termsParts } from '@tnn/domain'

/** A key point of the shipping terms, its figures (2,000 บาท, 7 วัน) bold and underlined: on the bill and where the sender signs */
export function TermsPoint({ point }: { point: string }) {
  return termsParts(point).map((part, i) =>
    part.figure ? (
      // biome-ignore lint/suspicious/noArrayIndexKey: the parts of one sentence, in order
      <strong key={i}>
        <u>{part.text}</u>
      </strong>
    ) : (
      // biome-ignore lint/suspicious/noArrayIndexKey: the parts of one sentence, in order
      <span key={i}>{part.text}</span>
    ),
  )
}
